<template>
	<div class="coupon-control">
		<filter-panel :data="groups" @search="filterChange"></filter-panel>
		<div style="padding: 15px 20px; text-align: right">
			<el-button type="primary" size="medium" @click="onaddCoupon">新建优惠券</el-button>
		</div>
		<data-list
			:data="data"
			:columns="column"
			:page="page"
			:loading="loading"
			:table-style="{ name: 'mixture' }"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		>
		</data-list>

		<form-dialog
			:dialogVisible.sync="dialogVisible"
			:formData="formData"
			@handleClose="onclose"
			:dialogTitle="dialogTitle"
			ref="formData"
			dialogWidth="600px"
		>
			<dialog-footer
				align="center"
				:visible.sync="dialogVisible"
				@confirm="submit"
				@onclose="onclose"
			></dialog-footer>
		</form-dialog>
	</div>
</template>

<script>
import listPageCreate from '@/mixins/listPageCreate';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import barCard from '@/components/customPageCard/barCard.vue';
import formDialog from '@/components/webManage/formDialog.vue';
import { getDatePoint, asyncCatch, transformdata } from '@/common/util.js';
import dialogFooter from '@/components/crm/crm-dialog-footer.vue';
import couponSer from '@/backend/services/coupon/couponSer.js';
import api from '@/backend/apiConfig/apiConfig';
import filters from '@/mixins/filters.js';
import { validRequired } from '@/common/elementValid.js';
import { GetMonthStr } from '@/utils/index.js';
import customer from '@/mixins/customer';

import { currencies } from '@/common/dictionary.js';

let { rmb, money } = filters.filters;

const list = listPageCreate({
	searchConfig: {
		api: api.coupon.couponList,
		method: 'POST',
	},
});
export default {
	name: 'couponControl',
	mixins: [list, customer],
	components: {
		filterPanel,
		barCard,
		formDialog,
		dialogFooter,
	},
	data() {
		let statusList = [
			{
				label: '有效',
				value: '1',
				colorClass: 'normalText',
			},
			{
				label: '使用中',
				value: '2',
				colorClass: 'warning',
			},
			{
				label: '作废',
				value: '3',
				colorClass: 'danger',
			},
			{
				label: '已过期',
				value: '4',
				colorClass: 'deathText',
			},
			{
				label: '已使用',
				value: '5',
				colorClass: 'deathText',
			},
		];
		let self = this;
		return {
			dialogTitle: '新增优惠券',
			groups: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '优惠券编号',
						label: '优惠券编号',
						prop: 'code',
						value: '',
					},
					{
						tagName: 'sky-input',
						placeholder: '名称',
						label: '名称',
						prop: 'name',
						value: '',
					},
					{
						label: '截止时间',
						startPlaceholder: '截止开始日期',
						endPlaceholder: '截止结束日期',
						prop: ['startDate', 'endDate'],
						tagName: 'sky-date-picker',
						type: 'daterange',
						value: [],
					},
				],
				multiples: [
					{
						defaultText: '指定功能',
						placeholder: '指定功能',
						label: '指定功能',
						prop: 'functionItemId',
						options: [],
						props: {
							label: 'name',
							value: 'id',
						},
						value: '',
					},
					{
						defaultText: '状态',
						placeholder: '状态',
						label: '状态',
						prop: 'status',
						options: statusList,
						value: '',
					},
				],
			},
			column: [
				{
					label: '优惠券编号',
					bind: 'code',
					showOverflowTooltip: true,
				},
				{
					label: '名称',
					bind: 'name',
					showOverflowTooltip: true,
				},
				{
					label: '指定功能',
					bind: 'functionItemName',
					showOverflowTooltip: true,
				},
				{
					label: '指定客户',
					bind: 'customerName',
					showOverflowTooltip: true,
				},
				{
					label: '金额',
					showOverflowTooltip: true,
					bind: (row, index) => {
						let { typeName, amount, currency } = row;

						return `${typeName} ${money(amount, currency, true)}`;
					},
				},
				{
					label: '截止时间',
					bind: 'expirationDate',
					showOverflowTooltip: true,
				},
				{
					label: '申请附件',
					bind: 'fileList',
					type: 'previewUploadFile',
				},
				{
					label: '创建时间',
					bind: 'createTime',
					showOverflowTooltip: true,
				},
				{
					label: '创建人',
					bind: 'createrName',
				},
				{
					label: '备注',
					bind: 'remarks',
					showOverflowTooltip: true,
				},
				{
					label: '状态',
					bind: 'statusName',
					showHover: true,
					width: 150,
					hoverContent: 'orderCode',
					className(row) {
						let item = statusList.find(item => item.value == row.status);
						return item.colorClass || '';
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'center',
					style: 'text',
					width: 150,
					bind: row => [
						{
							text: '查看编辑',
							trigger: function (row, btn) {
								self.dialogTitle = '编辑优惠券';
								self.getDetails(row);
							},
							showButton() {
								return self.btnStatus(row);
							},
						},
						{
							text: '作废',
							trigger(row, btn) {
								self.setNullify(row.id);
							},
							showButton() {
								return self.btnStatus(row);
							},
						},
						{
							text: '复制',
							trigger(row, btn) {
								self.dialogTitle = '复制优惠券';
								self.getDetails(row, true);
							},
						},
					],
				},
			],
			dialogVisible: false,
			formData: {},
			functionList: [],
			customerList: [],
			flag: '',
			itemId: '',
		};
	},
	methods: {
		btnStatus(row) {
			let noUse = [2, 3, 4, 5]; //使用中 过期 已使用 作废
			return !noUse.includes(row.status);
		},
		async getfunctionList() {
			let [err, res] = await asyncCatch(couponSer.getFunctionList);
			if (res) {
				this.functionList = res.data;
				this.groups.multiples[0].options = res.data;
				this.formData.functionItemId.options = res.data;
			}
		},
		async getcustomerList(name) {
			let [err, res] = await asyncCatch(couponSer.getCustomerList, { name });
			if (res) {
				this.customerList = res.data;
				this.formData.customerIdList.options = res.data;
			}
		},
		async getDetails(row, isCopy) {
			this.flag = isCopy ? 'copy' : 'edit';
			this.itemId = row.id;
			let [err, res] = await asyncCatch(couponSer.getCoupon, { id: row.id });
			if (res) {
				this.setFormData(res.data);
			}
			this.dialogVisible = true;
		},
		async setNullify(id) {
			let [err, res] = await asyncCatch(couponSer.setNullify, { id });
			if (res) {
				this.$message.success('操作成功');
				this.query();
			}
		},
		// 设置表单项
		setFormData(_form = {}) {
			// 常量定义
			const DEFAULT_CURRENCY_ID = 127001;

			// 辅助函数：根据币种ID过滤并映射功能列表
			const getFilteredFunctionList = currencyId => {
				const currencyInfo = currencies.find(item => item.value === currencyId);
				if (!currencyInfo) return [];

				const { symbol } = currencyInfo;

				return this.functionList
					.filter(item => item.priceList.some(({ currency }) => currency === currencyId))
					.map(item => {
						// 找到对应币种的价格信息
						const priceInfo = item.priceList.find(({ currency }) => currency === currencyId);
						return {
							...item,
							symbol,
							price: priceInfo ? priceInfo.price : 0, // 如果没有找到价格信息，默认为0
						};
					});
			};

			// 确定当前使用的币种ID
			const currentCurrencyId = _form.currency || DEFAULT_CURRENCY_ID;

			// 生成初始化的功能列表选项
			const initialFunctionOptions = getFilteredFunctionList(currentCurrencyId);

			// 验证规则：正整数
			const validInt = (rule, value, callback) => {
				// 优化逻辑：先检查是否为数字，再检查是否大于0
				const num = Number(value);
				if (!Number.isInteger(num) || num <= 0) {
					callback(new Error('请输入正整数'));
				} else {
					callback();
				}
			};

			// 获取下个月日期 (假设 getDatePoint 无参调用即返回下个月)
			const nextMonthDate = getDatePoint();

			// 构建表单数据
			this.formData = {
				name: {
					label: '名称',
					formType: 'sky-input',
					value: _form.name || '',
					placeholder: '请输入名称',
					rules: [validRequired('请输入名称')],
				},
				currency: {
					label: '优惠币种',
					formType: 'sky-select',
					customOption: true,
					setOptionValue: item => `${item.symbol}`,
					value: currentCurrencyId,
					options: currencies,
					placeholder: '请选择优惠币种',
					rules: [validRequired('请选择优惠币种', 'blur')],
					change: val => {
						// 币种改变时，重置功能项并更新选项列表
						this.formData.functionItemId.value = '';
						this.formData.functionItemId.options = getFilteredFunctionList(val);
					},
				},
				functionItemId: {
					label: '指定功能',
					formType: 'sky-select',
					customOption: true,
					setOptionValue: item => `原功能单价 ${item.symbol}${item.price}`,
					props: {
						label: 'name',
						value: 'id',
					},
					value: _form.functionItemId || '',
					options: initialFunctionOptions,
					placeholder: '请选择指定功能',
					rules: [validRequired('请选择指定功能', 'blur')],
				},
				amount: {
					label: '优惠金额',
					formType: 'sky-input',
					inputType: 'number',
					value: _form.amount || '',
					placeholder: '请输入金额',
					// rules: [validRequired('请输入金额'), { trigger: 'blur', validator: validInt }],
					rules: [validRequired('请输入金额')],
				},
				type: {
					label: '金额类别',
					formType: 'sky-radio',
					value: _form.type || '',
					options: [
						{ label: '服务费', value: 1 },
						{ label: '预存费', value: 2 },
						{ label: '增值税', value: 3 },
					],
					rules: [validRequired('请选择金额类别', 'blur')],
				},
				customerIdList: {
					label: '指定客户',
					formType: 'sky-select',
					multiple: true,
					filterable: true,
					// 优化：简化三元表达式逻辑
					value: this.flag === 'copy' ? [] : _form.customerIdList || [],
					props: {
						label: 'name',
						value: 'id',
					},
					options: this.customerList,
					placeholder: '请选择指定客户',
					rules: [validRequired('请选择指定客户', 'blur')],
				},
				expirationDate: {
					label: '截止时间',
					formType: 'sky-date-picker',
					value: _form.expirationDate || nextMonthDate,
					type: 'date',
					valueFormat: 'yyyy-MM-dd',
					rules: [validRequired('请选择截止时间', 'blur')],
					pickerOptions: {
						disabledDate: time => {
							// 假设 GetMonthStr(1, 'day') 返回包含 now 属性的对象
							const dateStr = GetMonthStr(1, 'day');
							const start = new Date(dateStr.now).getTime();
							return time.getTime() < start;
						},
					},
				},
				mallFlag: {
					label: '是否商城可用',
					formType: 'sky-switch',
					value: _form.mallFlag || false,
				},
				fileList: {
					label: '申请附件',
					formType: 'sky-uploadImg',
					platform: 'iglobalwin-pri-oss',
					limit: 1,
					value: _form.fileList || [],
				},
				remarks: {
					label: '备注',
					formType: 'sky-textarea',
					value: _form.remarks,
					maxlength: 500,
					'show-word-limit': true,
					rows: 5,
				},
			};
		},
		submit(cb) {
			this.$refs.formData.validate(valid => {
				if (valid) {
					cb();
					let param = transformdata(this.formData);

					const _query = () => {
						this.dialogVisible = false;
						this.query();
					};
					const add = async () => {
						let [err, res] = await asyncCatch(couponSer.addCoupon, param);
						if (res) {
							_query();
						}
						cb(false);
					};
					const edit = async () => {
						let res = await couponSer.editCoupon({ id: this.itemId }, param);
						if (res.status >= 200 && res.status < 400) {
							this.itemId = '';
							_query();
						}
						cb(false);
					};
					this.flag == 'add' || this.flag == 'copy' ? add() : edit();
				}
			});
		},
		onaddCoupon() {
			this.dialogTitle = '新增优惠券';
			this.flag = 'add';
			this.setFormData();
			this.dialogVisible = true;
		},
		onclose() {
			this.$nextTick(() => {
				this.$refs.formData.reset();
				this.$refs.formData.clearValidate();
			});
		},
	},
	mounted() {
		this.query();
		this.getfunctionList();
		this.getcustomerList();
		this.setFormData();
	},
	activated() {
		this.query();
	},
	destroyed() {
		this.flag = '';
		this.itemId = '';
	},
};
</script>

<style lang="scss" scoped></style>
